"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const format_1 = require("./abstract/format");
const Registry = require("../registry");
class BlockBlot extends format_1.default {
    static formats(domNode) {
        let tagName = Registry.query(BlockBlot.blotName).tagName;
        if (domNode.tagName === tagName)
            return undefined;
        return super.formats(domNode);
    }
    format(name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
        }
        else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
        }
        else {
            super.format(name, value);
        }
    }
    formatAt(index, length, name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
        }
        else {
            super.formatAt(index, length, name, value);
        }
    }
    insertAt(index, value, def) {
        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            super.insertAt(index, value, def);
        }
        else {
            let after = this.split(index);
            let blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
        }
    }
    update(mutations, context) {
        if (navigator.userAgent.match(/Trident/)) {
            this.build();
        }
        else {
            super.update(mutations, context);
        }
    }
}
BlockBlot.blotName = 'block';
BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
BlockBlot.tagName = 'P';
exports.default = BlockBlot;
